<template>
	<div class="content-box">
		<div class="operator">
			<div class="operator-col">
				<warehouse-input v-model="filterWarehouse"></warehouse-input>
			</div>
			<div class="operator-col">
				<hispickup v-model="filterHisDate"></hispickup>
			</div>
			<div class="operator-col">
				<editor-relateid
					size="mini"
					v-model="filterModel"
					data-model-name="Model"
					:name-fields="['name']"
					:params="{allowCreate:false,placeholder:'搜索尺寸'}"
				></editor-relateid>
			</div>
		</div>
		<curd-table
			ref="listTable"
			:data-model="listDataModel"
			:fields="tableFields"
			@doedit="handleEdit($event)"
			:date-filter="filterHisDate"
			:search-filter="filterTableSearch"
			:has-delete="false"
			:kv-filter="kvFilter"
			:list-url="'inventory/list_tx_item/'+recordId"
		>
			<template slot="listOp" slot-scope="scope">
				<el-button size="mini" type="text" @click="goTxInfo(scope.row.transaction._id)">详情</el-button>
			</template>
		</curd-table>
	</div>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import FilterWarehouse from "@/mixins/Filter/FilterWarehouse.js";
import FilterModel from "@/mixins/Filter/FilterModel.js";

import TxOp from "@/mixinsApp/TxOp.js";

const TX_TYPE_OUTBOUND = 20;
const TX_TYPE_INBOUND = 21;
const TX_TYPE_SCHEDULE = 40;
const TX_TYPE_ST = 31;
const TX_TYPE_ST_OUTCOME = 32;
const TX_TYPE_ST_INIT = 99;

export default {
	mixins: [CurdPage, Filters, FilterWarehouse, FilterModel, TxOp],
	data() {
		return {
			loadings: {
				main: false,
				create: false,
				warehouse: false,
			},
			filterHisDate: [],
			filterTableSearch: "",
			listDataModel: "Tx_item",
			editorId: "",
			tableFields: [
				{
					name: "transaction",
					isTrans: false,
					sortable: false,
				},
				{
					name: "warehouse",
					isTrans: true,
					sortable: "custom",
					isTag: true,
				},
				{
					name: "model",
					sortable: "custom",
				},

				{
					name: "type",
					isTrans: false,
					sortable: false,
				},
				{
					name: "amount",
					isTrans: false,
					sortable: false,
				},
				{
					name: "status",
					isTrans: false,
					sortable: false,
				},

				{
					name: "created_at",
					isTrans: false,
					sortable: false,
				},
				{
					name: "created_user",
					isTrans: false,
					sortable: false,
				},
			],
		};
	},
	props: {
		recordId: {
			type: String,
			default: "",
		},
	},
	watch: {},
	created() {
		//this.replaceTableFields();
	},
	mounted() {},
	methods: {
		refreshTable() {
			this.$refs["listTable"].refreshData();
		},
	},
};
</script>
<style lang="scss" scoped>
</style>
